interface Props { status: string; statusFormatted: string; className?: string; }

const COLORS: Record<string, string> = {
    NOT_STARTED: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
    IN_PROGRESS: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300',
    PARTIALLY_VALIDATED: 'bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300',
    DONE: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
};

const BatchStatusBadge = ({ status, statusFormatted, className = '' }: Props) => {
    const color = COLORS[status] || COLORS.NOT_STARTED || 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300';
    return <span className={`px-2 py-0.5 rounded text-[10px] font-medium ${color} ${className}`}>{statusFormatted || '—'}</span>;
};

export default BatchStatusBadge;
